module.exports = __webpack_public_path__ + "static/media/bbq-text-1.5bbd0a3c.jpg";